type TermsCheckboxProps = {
  agreePrefix: string;
  linkText: string;
  linkHref: string;
};

export function TermsCheckbox({ agreePrefix, linkText, linkHref }: TermsCheckboxProps) {
  return (
    <div className="relative flex items-start">
      <input
        id="terms"
        name="terms"
        type="checkbox"
        required
        className="mt-0.5 size-4 cursor-pointer rounded border-spark-border-default text-spark-accent focus:ring-spark-accent-hover"
      />
      <label htmlFor="terms" className="ml-3 inline cursor-pointer text-sm text-spark-text-primary">
        {agreePrefix}{' '}
        <a
          href={linkHref}
          target="_blank"
          rel="noopener noreferrer"
          className="font-medium text-spark-accent hover:text-spark-accent-hover"
        >
          {linkText}
        </a>
      </label>
    </div>
  );
}
